var _path, _path2, _path3, _path4, _path5, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemBgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 412,
    viewBox: "0 0 430 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter0_f_2785_1786)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.396 288.064H65.6055L206.664 75L363.396 288.064Z",
    fill: "url(#paint0_linear_2785_1786)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter1_f_2785_1786)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.396 123.594H65.6055L206.664 336.657L363.396 123.594Z",
    fill: "url(#paint1_linear_2785_1786)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.035 214.78C287.994 214.711 287.972 214.633 287.974 214.553L288.091 209.508L283.78 212.131C283.712 212.173 283.633 212.194 283.553 212.192L278.508 212.075L281.132 216.386C281.173 216.455 281.194 216.533 281.192 216.613L281.076 221.658L285.387 219.035C285.455 218.993 285.534 218.972 285.614 218.974L290.659 219.09L288.035 214.78Z",
    fill: "#FFF4A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.653 184.828C147.625 184.783 147.611 184.731 147.613 184.677L147.69 181.328L144.829 183.07C144.783 183.098 144.731 183.112 144.678 183.11L141.329 183.033L143.07 185.894C143.098 185.94 143.112 185.992 143.111 186.045L143.033 189.394L145.895 187.653C145.94 187.625 145.992 187.611 146.046 187.612L149.395 187.69L147.653 184.828Z",
    fill: "#FFF4A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.187 264.21C147.137 264.182 147.096 264.141 147.069 264.092L145.348 260.946L143.628 264.092C143.601 264.141 143.56 264.182 143.51 264.21L140.364 265.93L143.51 267.65C143.56 267.678 143.601 267.719 143.628 267.768L145.348 270.914L147.069 267.768C147.096 267.719 147.137 267.678 147.187 267.65L150.332 265.93L147.187 264.21Z",
    fill: "#FFF4A4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.492,
    cy: 153.492,
    rx: 2.49197,
    ry: 2.49197,
    fill: "#FFF4A4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2785_1786",
    x: -9.1537,
    y: 0.240829,
    width: 447.309,
    height: 362.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3796,
    result: "effect1_foregroundBlur_2785_1786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2785_1786",
    x: -9.1537,
    y: 48.8343,
    width: 447.309,
    height: 362.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3796,
    result: "effect1_foregroundBlur_2785_1786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2785_1786",
    x1: 214.501,
    y1: 75,
    x2: 214.501,
    y2: 288.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC9744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D53928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2785_1786",
    x1: 214.501,
    y1: 336.657,
    x2: 214.501,
    y2: 123.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC9744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D53928"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemBgPoints);
export default __webpack_public_path__ + "static/media/gem-bg-points.887f86f0025aec0a5924665bb1992936.svg";
export { ForwardRef as ReactComponent };